import script from "./Pruoto.vue?vue&type=script&setup=true&lang=js"
export * from "./Pruoto.vue?vue&type=script&setup=true&lang=js"

import "./Pruoto.vue?vue&type=style&index=0&id=0c37a6a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c37a6a6"]])

export default __exports__